var map = {
	"./chat.png": "uKN4",
	"./cogs.png": "hkPi",
	"./fresh.svg": "cc9Q",
	"./location.png": "Koby",
	"./piggy.png": "5xwS",
	"./switch.png": "1ZQV",
	"./timer.png": "VJsP",
	"./trend.png": "fIeC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v4gn";